import React from "react"
export function NoMeals(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M17.943 1L19 2.06l-.956.954v-.002L2.053 19 1 17.946l4.987-4.989.001-3.97A1.997 1.997 0 013.991 6.99V1.998h1.248v3.494a.5.5 0 001 0V1.998h1.496v3.494a.5.5 0 00.998 0V1.998h1.25V6.99a1.997 1.997 0 01-1.997 1.996l-.001 1.974 3.381-3.383c.477-3.72 1.348-5.579 2.614-5.579h.996v1.97L17.942 1zm-2.968 7.195l.001 9.776H12.98v-4.992h-1.004a.999.999 0 01-.944-.84l3.944-3.944zm-6.99 6.988v2.788H5.989v-.791l1.997-1.997z"
        fill="currentColor"
        id="prefix__no-meals"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
